import Immutable from 'seamless-immutable';
import _ from 'lodash';

const DATA_REQUEST = 'DATA_REQUEST';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const INSERT_UPDATE_ITEMS = 'INSERT_UPDATE_ITEMS';
const DELETE_ITEMS = 'DELETE_ITEMS';
const INIT_STATE = 'INIT_STATE';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) =>
  Immutable.asMutable(_.get(state, reducerName), { deep: true });

const createReducer = reducerName => {
  function stateDefault() {
    return {
      name: 'objectCollection',
      requestsStates: {},
      itemsById: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(reducerName, DATA_REQUEST):
        return state.merge({
          requestsStates: {
            ...state.requestsStates,
            ...{
              [action.payload.objectId]: {
                requestInProcess: action.payload.hasSetInProgress,
                lastStatusCode: null,
                countQueries: state.requestsStates[action.payload.objectId]
                  ? state.requestsStates[action.payload.objectId].countQueries
                  : 0
              }
            }
          }
        });
      case createActionName(reducerName, REQUEST_FINISHED):
        return state.merge({
          requestsStates: {
            ...state.requestsStates,
            ...{
              [action.payload.objectId]: {
                requestInProcess: false,
                lastStatusCode: action.payload.code,
                countQueries:
                  state.requestsStates[action.payload.objectId].countQueries + 1
              }
            }
          }
        });
      case createActionName(reducerName, INSERT_UPDATE_ITEMS):
        return state.merge(
          {
            itemsById: { ...state.itemsById, ...action.payload.itemsById }
          },
          { deep: true }
        );
      case createActionName(reducerName, DELETE_ITEMS): {
        const clone = Immutable.asMutable(state, { deep: true });
        action.payload.itemsKeys.map(key => {
          if (key in clone.itemsById) {
            delete clone.itemsById[key];
          }
          return null;
        });
        return clone;
      }
      case createActionName(reducerName, INIT_STATE):
        return Immutable({
          ...stateDefault(),
          ...{ mergeItemsMode: action.payload === true }
        });
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS CREATOR
export const dataRequest = (
  reducerName,
  objectId,
  hasSetInProgress = true
) => ({
  type: createActionName(reducerName, DATA_REQUEST),
  payload: { objectId, hasSetInProgress }
});
export const requestFinished = (reducerName, objectId, code) => ({
  type: createActionName(reducerName, REQUEST_FINISHED),
  payload: { code, objectId }
});
export const insertUpdateItems = (reducerName, itemsById) => ({
  type: createActionName(reducerName, INSERT_UPDATE_ITEMS),
  payload: { itemsById }
});
export const deleteItems = (reducerName, itemsKeys) => ({
  type: createActionName(reducerName, DELETE_ITEMS),
  payload: { itemsKeys }
});
export const initState = (reducerName, payload) => ({
  type: createActionName(reducerName, INIT_STATE),
  payload
});

// SELECTORS
export const selectIdsByGroupId = (state, reducerName, id) => {
  const ids = getState(state, reducerName).groupMapItemsIds[id];
  if (ids) {
    return ids;
  }
  return [];
};

export const selectItemById = (state, reducerName, id) => {
  const ids = getState(state, reducerName).itemsById[id];
  if (ids) {
    return ids;
  }
  return null;
};

export const selectRequestsStateById = (state, reducerName, id) => {
  const requestState = getState(state, reducerName).requestsStates[id];
  if (requestState) {
    return requestState;
  }
  return {
    requestInProcess: false,
    lastStatusCode: null,
    countQueries: 0
  };
};



// WEBPACK FOOTER //
// ./src/mt-react-common/common/reducers/objectCollection/reducer.js